module.exports = new __parcel__URL__("recruitment_ko.7d460107.webp").toString();